/* unplugin-vue-components disabled */import script from "./OutOfStockDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./OutOfStockDialog.vue?vue&type=script&setup=true&lang=js"

import "./OutOfStockDialog.vue?vue&type=style&index=0&id=0d299a60&lang=scss"

const __exports__ = script;

export default __exports__